import { render, staticRenderFns } from "./macro-navigation-section.vue?vue&type=template&id=e90bffe4&scoped=true&"
import script from "./macro-navigation-section.vue?vue&type=script&lang=js&"
export * from "./macro-navigation-section.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=e90bffe4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90bffe4",
  null
  
)

export default component.exports